module.exports = __webpack_public_path__ + "static/media/footerLocation.bec96a51.svg";